"use strict";
/*
    based on:
        https://github.com/technically-php/linear-partitioning/blob/master/src/LinearPartitioning.php
    which is based on:
        http://www8.cs.umu.se/kurser/TDBAfl/VT06/algorithms/BOOK/BOOK2/NODE45.HTM
    related stackoverflow thread:
        https://stackoverflow.com/questions/7938809/how-to-understand-the-dynamic-programming-solution-in-linear-partitioning/7942946
*/
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.linearPartition = void 0;
var lodash_sortby_1 = __importDefault(require("lodash.sortby"));
var initPrefixSumsArray = function (S, n) {
    var P = [0];
    for (var i = 1; i <= n; ++i) {
        P[i] = P[i - 1] + S[i];
    }
    return P;
};
var initBoundaries = function (S, P, n, k) {
    var M = [];
    for (var i = 1; i <= n; ++i) {
        M[i] = [];
        // The only possible partitioning of i elements to 1 range is a single all-elements range
        // The cost of that partitioning is the sum of those i elements
        M[i][1] = P[i]; // sum of {S[1], ..., S[i]} -- optimized using P
    }
    for (var i = 1; i <= k; ++i) {
        // The only possible partitioning of 1 element into i ranges is a single one-element range
        // The cost of that partitioning is the value of first element
        M[1][i] = S[1];
    }
    return M;
};
var initPositions = function (n) {
    var D = [];
    for (var i = 0; i <= n; ++i) {
        D.push([]);
    }
    return D;
};
var reconstructPartitioning = function (S, D, n, k) {
    var i = n;
    var j = k;
    var partition = [];
    while (j > 0) {
        var delimiterPosition = D[i][j] || 0;
        // Add elements after delimiter {S[delimiterPosition], ..., S[i]} to resulting partition.
        partition.push(S.slice(delimiterPosition + 1, i + 1));
        // Step forward: look for delimiter position for partitioning M[delimiterPosition, j-1]
        i = delimiterPosition;
        --j;
    }
    // Fix order as we reconstructed the partitioning from end to start
    // Ignoring possibly empty rows, appearing when there are no delimiters for the given `j` index.
    return partition.reverse().filter(function (row) { return row.length > 0; });
};
function linearPartition(elements, maxRanges) {
    var n = elements.length;
    var k = maxRanges;
    // An array S of non-negative numbers {S[1], .., S[n]}
    var S = __spread([0], elements); // adapt indices here: [0..n-1] => [1..n]
    // Let D[n,k] be the position of K-th divider
    // which produces the minimum possible cost partitioning of N elements to K ranges
    var D = initPositions(n);
    // We don't use zero indices for `M` and `D` to make code match math formulas
    // Let P be the sum of first i elements (cost calculation optimization)
    var P = initPrefixSumsArray(S, n);
    // Let M[n,k] be the minimum possible cost over all partitionings of N elements to K ranges
    var M = initBoundaries(S, P, n, k);
    // Main recurrence (fill the rest of values in table M)
    for (var i = 2; i <= n; ++i) {
        for (var j = 2; j <= k; ++j) {
            var solutions = [];
            for (var x = 1; x <= i - 1; ++x) {
                solutions.push({
                    cost: Math.max(M[x][j - 1], P[i] - P[x]),
                    delimiter: x,
                });
            }
            var sortedSolutions = lodash_sortby_1.default(solutions, 'cost');
            var bestSolution = sortedSolutions[0];
            M[i][j] = bestSolution.cost;
            D[i][j] = bestSolution.delimiter;
        }
    }
    return reconstructPartitioning(S, D, n, k);
}
exports.linearPartition = linearPartition;
//# sourceMappingURL=linearPartition.js.map